module.exports = __webpack_public_path__ + "static/media/emmanuel.f3aeadb3.png";